import * as React from 'react';
import * as _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { PARTS } from './../../schemas/accessRightsModel';
import { isAgentVisible } from './../../schemas/commonAccess';
import * as backend from './../../utilities/backend';
import CentralHubJobBoardNotification from '../../components/PageLayout/CentralHubJobBoardNotification';
import SvgIcons from '../../components/Icons/SvgIcons';
import CentralHubReferralButton from '../../components/PageLayout/CentralHubButtons/CentralHubReferralButton';
export default function () {
    function onClick1(AR) {
        this.props.go('stones');
    }
    function onClick2(AR) {
        this.props.go('jobboard');
    }
    function onClick3(AR) {
        this.props.go('jobboard');
    }
    function onClick4(AR) {
        this.goToNewQuote(false, 'kitchen');
    }
    function onClick5(AR) {
        this.goToNewQuote(false, 'kitchen', true);
    }
    function onClick6(AR) {
        this.goToNewQuote(true, 'kitchen');
    }
    function onClick7(AR) {
        this.goToNewQuote(false, 'visualizer');
    }
    function onClick8(AR) {
        this.goToNewQuote(false, 'visualizer', true);
    }
    function onClick9(AR) {
        this.goToNewQuote(true, 'visualizer');
    }
    function onClick10(AR) {
        this.goToNewQuote(true, 'fireplace');
    }
    function onClick11(AR) {
        this.goToNewQuote(true, 'laundryroom');
    }
    function onClick12(AR) {
        this.customerClickHandler();
    }
    function onClick13(AR) {
        this.props.go('fabricators');
    }
    function onClick14(AR) {
        this.employeesClickHandler();
    }
    function onClick15(AR) {
        this.props.go('account?clientType=Client');
    }
    function onClick16(AR) {
        this.props.go('stores');
    }
    function onClick17(AR) {
        this.props.go('scope');
    }
    function onClick18(AR) {
        this.props.go('pricing');
    }
    function onClick19(AR) {
        this.props.go('newscope');
    }
    function onClick20(AR) {
        this.props.go('featureInclusion');
    }
    function onClick21(AR) {
        this.props.go('installations');
    }
    function onClick22(AR) {
        this.props.go('sites');
    }
    function onClick23(AR) {
        this.props.go('stones');
    }
    function onClick24(AR) {
        this.props.go('stones/pricing');
    }
    function onClick25(AR) {
        this.props.go('email-templates');
    }
    function onClick26(AR) {
        this.props.go('filters');
    }
    function onClick27(AR) {
        this.props.go('taxes');
    }
    function onClick28(AR) {
        this.props.go('visualizer-management');
    }
    function onClick29(AR) {
        this.props.go('discounts');
    }
    function onClick30(AR) {
        this.props.go('agent');
    }
    function onClick31(AR) {
        this.props.go('wizard');
    }
    function onClick32(AR) {
        this.goToNewQuote(false, 'dealer');
    }
    function scopeAR33() {
        var AR = this.props.AR;
        return React.createElement('div', { 'className': 'app-content-main' }, React.createElement('div', { 'className': classNames('central-hub-banner-wrapper', { 'central-hub-banner-wrapper--encore': this.props.isEncoreClient }) }, React.createElement('div', { 'className': 'central-hub-banner-dashboard' }, AR.v(PARTS.HUB_BUTTON_STONE_SETUP) && !this.props.isEncoreClient ? React.createElement('div', {
            'className': 'central-hub-banner-button-container',
            'key': '936'
        }, React.createElement('h1', {}, React.createElement(FormattedMessage, { 'id': 'centralHub.stoneSetupMessage' })), React.createElement('div', {
            'className': 'central-hub-banner-button',
            'onClick': onClick1.bind(this, AR)
        }, React.createElement(FormattedMessage, { 'id': 'centralHub.stoneSetupButton' }))) : null), React.createElement('div', { 'className': 'central-hub-banner-jobboard' }, !this.props.isEncoreClient ? React.createElement('div', {
            'className': 'central-hub-banner-button-container',
            'key': '1380'
        }, React.createElement('h1', {}, React.createElement(FormattedMessage, { 'id': 'centralHub.jobBoardMessage' })), React.createElement('div', {
            'className': 'central-hub-banner-button',
            'onClick': onClick2.bind(this, AR)
        }, React.createElement(FormattedMessage, { 'id': 'centralHub.jobBoardButton' }))) : null)), React.createElement('div', { 'className': 'central-hub-icons-flex-container' }, AR.v(PARTS.HUB_BUTTON_JOB_BOARD) && !this.props.isEncoreClient ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'onClick': onClick3.bind(this, AR),
            'key': '2024'
        }, React.createElement(CentralHubJobBoardNotification, {}), React.createElement('div', { 'className': 'central-hub-icon-frame central-hub-icon-job-board' }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.jobBoard' }))) : null, this.props.hasKitchen && !this.props.isEncoreClient && !this.state.disallowQuoteButtonFor.includes('kitchen') && (AR.v(PARTS.HUB_BUTTON_ADD_QUOTE) || AR.isSiteAdmin(false)) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'onClick': onClick4.bind(this, AR),
            'key': '2435'
        }, React.createElement('div', { 'className': 'central-hub-icon-frame central-hub-icon-add-quote' }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.kitchenQuote' }))) : null, this.props.hasKitchen && !this.props.isEncoreClient && !this.state.disallowQuoteButtonFor.includes('kitchen') && AR.v(PARTS.HUB_BUTTON_KITCHEN_QUOTE_OFFLINE) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'onClick': onClick5.bind(this, AR),
            'key': '2944'
        }, React.createElement('div', { 'className': 'central-hub-icon-frame central-hub-icon-add-quote' }), React.createElement('h1', {}, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.kitchenQuoteOffline' }))) : null, this.props.hasKitchen && backend.getManaging() == 'BathDB' && (AR.v(PARTS.HUB_BUTTON_ADD_KV_QUOTE) || AR.isSiteAdmin(false)) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'onClick': onClick6.bind(this, AR),
            'key': '3405'
        }, React.createElement('div', { 'className': 'central-hub-icon-frame central-hub-icon-kitchen-visualizer' }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.kitchenDesign' }))) : null, this.props.hasBathroom && !this.props.isEncoreClient && !this.state.disallowQuoteButtonFor.includes('bathroom') && AR.v(PARTS.HUB_BUTTON_ADD_BV_QUOTE) || AR.isSiteAdmin(false) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'onClick': onClick7.bind(this, AR),
            'key': '3864'
        }, React.createElement('div', { 'className': 'central-hub-icon-frame central-hub-icon-add-quote' }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.bathRoomQuote' }))) : null, this.props.hasBathroom && !this.props.isEncoreClient && !this.state.disallowQuoteButtonFor.includes('bathroom') && AR.v(PARTS.HUB_BUTTON_BATHROOM_QUOTE_OFFLINE) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'onClick': onClick8.bind(this, AR),
            'key': '4383'
        }, React.createElement('div', { 'className': 'central-hub-icon-frame central-hub-icon-add-quote' }), React.createElement('h1', {}, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.bathRoomQuoteOffline' }))) : null, !this.isAmericanImport() && (this.props.hasBathroom && AR.v(PARTS.HUB_BUTTON_ADD_BV_QUOTE) || AR.isSiteAdmin(false)) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'onClick': onClick9.bind(this, AR),
            'key': '4851'
        }, React.createElement('div', { 'className': 'central-hub-icon-frame central-hub-bathroom-visualizer' }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.bathRoomDesign' }))) : null, '\r\n    ', console.log(this.props.hasFireplace, this.props, AR.v(PARTS.HUB_BUTTON_ADD_FP_QUOTE)), '\r\n    ', this.props.hasFireplace && backend.getManaging() == 'BathDB' && (AR.v(PARTS.HUB_BUTTON_ADD_FP_QUOTE) || AR.isSiteAdmin(false)) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'onClick': onClick10.bind(this, AR),
            'key': '5397'
        }, React.createElement('div', { 'className': 'central-hub-icon-frame central-hub-icon-fireplace-visualizer' }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.fireplaceDesign' }))) : null, this.props.hasLaundryRoom && backend.getManaging() == 'BathDB' && (AR.v(PARTS.HUB_BUTTON_ADD_LR_QUOTE) || AR.isSiteAdmin(false)) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'onClick': onClick11.bind(this, AR),
            'key': '5864'
        }, React.createElement('div', { 'className': 'central-hub-icon-frame central-hub-icon-laundryRoom-visualizer' }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.laundryRoomDesign' }))) : null, AR.v(PARTS.HUB_BUTTON_CUSTOMERS) && !this.props.isEncoreClient ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'onClick': onClick12.bind(this, AR),
            'key': '6339'
        }, React.createElement('div', { 'className': 'central-hub-icon-frame central-hub-icon-customers' }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.customers' }))) : null, AR.v(PARTS.HUB_BUTTON_FABRICATORS) && !(this.props.asCustomer && this.props.asCustomer.activeEntity && this.props.asCustomer.activeEntity.dashboardEntity && this.props.asCustomer.activeEntity.dashboardEntity === 'EmployeeFabricator') ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'onClick': onClick13.bind(this, AR),
            'key': '6712'
        }, React.createElement('div', { 'className': 'central-hub-icon-frame central-hub-icon-fabricators' }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.fabricators' }))) : null, AR.v(PARTS.HUB_BUTTON_EMPLOYEES) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'onClick': onClick14.bind(this, AR),
            'key': '7288'
        }, React.createElement('div', { 'className': 'central-hub-icon-frame central-hub-icon-employees' }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.employees' }))) : null, AR.v(PARTS.HUB_BUTTON_NEW_CUSTOMER) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'onClick': onClick15.bind(this, AR),
            'key': '7626'
        }, React.createElement('div', { 'className': 'central-hub-icon-frame central-hub-icon-new-customer' }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.newCustomer' }))) : null, AR.isSiteAdmin() ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'onClick': onClick16.bind(this, AR),
            'key': '8118'
        }, React.createElement('div', { 'className': 'central-hub-icon-frame central-hub-icon-stores' }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.stores' }))) : null, false ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'key': '8429'
        }, React.createElement('div', {
            'className': 'central-hub-icon-frame central-hub-icon-features',
            'onClick': onClick17.bind(this, AR)
        }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.products' }))) : null, AR.v(PARTS.HUB_BUTTON_PROJECT_SCOPE) && false ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'key': '8799'
        }, React.createElement('div', {
            'className': 'central-hub-icon-frame central-hub-icon-pricing',
            'onClick': onClick18.bind(this, AR)
        }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.pricing' }))) : null, AR.v(PARTS.HUB_BUTTON_PROJECT_SCOPE) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'key': '9142'
        }, React.createElement('div', {
            'className': 'central-hub-icon-frame central-hub-icon-features',
            'onClick': onClick19.bind(this, AR)
        }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.projectScope' }))) : null, AR.v(PARTS.HUB_BUTTON_FEATURE_INCLUSION) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'key': '9483'
        }, React.createElement('div', {
            'className': 'central-hub-icon-frame central-hub-icon-features',
            'onClick': onClick20.bind(this, AR)
        }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.featureInclusion' }))) : null, AR.v(PARTS.HUB_BUTTON_INSTALLATIONS) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'key': '9840'
        }, React.createElement('div', {
            'className': 'central-hub-icon-frame central-hub-icon-features',
            'onClick': onClick21.bind(this, AR)
        }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.installation' }))) : null, false ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'key': '10186'
        }, React.createElement('div', { 'className': 'central-hub-icon-frame central-hub-icon-misc' }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.miscellaneous' }))) : null, AR.v(PARTS.HUB_BUTTON_SITES) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'onClick': onClick22.bind(this, AR),
            'key': '10451'
        }, React.createElement('div', { 'className': 'central-hub-icon-frame central-hub-icon-sites' }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.sites' }))) : null, AR.v(PARTS.HUB_BUTTON_ACCOUNT_SETTINGS) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'key': '10771'
        }, React.createElement('div', { 'className': 'central-hub-icon-frame central-hub-icon-account-settings' }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.accountSettings' }))) : null, AR.v(PARTS.HUB_BUTTON_KITCHEN_VISUALIZER) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'key': '11084'
        }, React.createElement('div', { 'className': 'central-hub-icon-frame central-hub-icon-kitchen-visualizer' }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.kitchenVisualizer' }))) : null, AR.v(PARTS.HUB_BUTTON_STONE_SETUP) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'key': '11403'
        }, React.createElement('div', {
            'className': 'central-hub-icon-frame central-hub-icon-stone-suppliers',
            'onClick': onClick23.bind(this, AR)
        }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.stoneSetup' }))) : null, AR.v(PARTS.HUB_BUTTON_ASSIGN_PRICE_PROFILE) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'key': '11745'
        }, React.createElement('div', {
            'className': 'central-hub-icon-frame central-hub-icon-misc',
            'onClick': onClick24.bind(this, AR)
        }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.assignPricingProfile' }))) : null, AR.v(PARTS.HUB_BUTTON_DOCUMENTS) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'key': '12182'
        }, React.createElement('div', { 'className': 'central-hub-icon-frame central-hub-icon-documents' }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.documents' }))) : null, AR.v(PARTS.HUB_BUTTON_REPORTS) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'key': '12475'
        }, React.createElement('div', { 'className': 'central-hub-icon-frame central-hub-icon-reports' }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.reports' }))) : null, AR.v(PARTS.HUB_BUTTON_CONTACT_US) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'key': '13027'
        }, React.createElement('div', { 'className': 'central-hub-icon-frame central-hub-icon-contact' }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.contactUs' }))) : null, AR.isSiteAdmin() ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'key': '13420'
        }, React.createElement('div', {
            'className': 'central-hub-icon-frame central-hub-icon-email-templates',
            'onClick': onClick25.bind(this, AR)
        }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.emailTemplates' }))) : null, AR.isSiteAdmin() ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'key': '13850'
        }, React.createElement('div', {
            'className': 'central-hub-icon-frame central-hub-icon-create-filter',
            'onClick': onClick26.bind(this, AR)
        }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.filters' }))) : null, AR.v(PARTS.HUB_BUTTON_TAXES) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'key': '14561'
        }, React.createElement('div', {
            'className': 'central-hub-icon-frame central-hub-icon-create-filter',
            'onClick': onClick27.bind(this, AR)
        }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.taxes' }))) : null, AR.v(PARTS.HUB_BUTTON_VISUALIZER_MANAGEMENT) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'key': '14889'
        }, React.createElement('div', {
            'className': 'central-hub-icon-frame central-hub-icon-visualizer-management',
            'onClick': onClick28.bind(this, AR)
        }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.visualizerManagement' }))) : null, AR.v(PARTS.HUB_BUTTON_DISCOUNTS) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'key': '15351'
        }, React.createElement('div', {
            'className': 'central-hub-icon-frame central-hub-icon-discounts',
            'onClick': onClick29.bind(this, AR)
        }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.discounts' }))) : null, AR.v(PARTS.HUB_BUTTON_AGENT) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'key': '15687'
        }, React.createElement('div', {
            'className': 'central-hub-icon-frame central-hub-icon-agent',
            'onClick': onClick30.bind(this, AR)
        }, '\r\n        ', SvgIcons.coBrowseIcon, '\r\n      '), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.agent' }))) : null, AR.isSiteAdmin(false) || AR.v(PARTS.HUB_BUTTON_WIZARD) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'key': '16048'
        }, React.createElement('div', {
            'className': 'central-hub-icon-frame central-hub-icon-wizard',
            'onClick': onClick31.bind(this, AR)
        }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.wizardSetup' }))) : null, AR.isSiteAdmin(true) && !(this.props.asCustomer && this.props.asCustomer.activeEntity) ? React.createElement(CentralHubReferralButton, { 'key': '16402' }) : null, AR.isSiteAdmin(false) || AR.v(PARTS.HUB_BUTTON_DEALER) ? React.createElement('div', {
            'className': 'central-hub-icons-flex-item',
            'key': '16530'
        }, React.createElement('div', {
            'className': 'central-hub-icon-frame central-hub-icon-dealer',
            'onClick': onClick32.bind(this, AR)
        }), React.createElement('span', { 'className': 'central-hub-icons-flex-item__text' }, React.createElement(FormattedMessage, { 'id': 'centralHub.buttons.dealer' }))) : null));
    }
    return scopeAR33.apply(this, []);
}